<div class="row replay">
  <div class="replay--buttons">
    <span *ngIf="isMobile && !replayController?.isActive()">{{ 'tasks.replay.label-title' | translate }}:</span>
    <span *ngIf="!isMobile">{{ 'tasks.replay.label-title' | translate }}:</span>

    <button
      class="ellipsis-cards"
      [disabled]="!replayController?.canPlay() || replayController?.isRunning()"
      (click)="replayController.play()">
      <i class="agres-play agres-2x"></i>
    </button>

    <!-- Só o slider com *ngIf -->
    <ng-container *ngIf="replayController?.isActive()">
      <button
        class="ellipsis-cards"
        [disabled]="replayController?.canPlay()"
        (click)="replayController.pause()">
        <i class="agres-pause agres-2x"></i>
      </button>

      <button
        class="ellipsis-cards"
        [disabled]="!replayController?.canStop()"
        (click)="replayController.stop()">
        <i class="agres-stop agres-2x"></i>
      </button>

      <button
        class="ellipsis-cards"
        [disabled]="!replayController?.canStop()"
        (click)="replayController.stepOneBackwards()">
        <i class="agres-skip-back agres-2x"></i>
      </button>

      <button
        class="ellipsis-cards"
        [disabled]="!replayController?.canPlay() && !replayController?.canStop()"
        (click)="replayController.stepOneForward()">
        <i class="agres-skip-forward agres-2x"></i>
      </button>

      <button
        class="ellipsis-cards"
        [disabled]="!replayController?.canStop() || !replayController?.isRunning()"
        (click)="replayController.speedDown()">
        <i class="agres-fast-rewind agres-2x"></i>
      </button>

      <button
        class="ellipsis-cards"
        [disabled]="!replayController?.canStop() || !replayController?.isRunning()"
        (click)="replayController.speedUp()">
        <i class="agres-fast-forward agres-2x"></i>
      </button>
      <div class="row replay--matSlider">
        <mat-slider class="replay-slider" step="2" min="0" [max]="replayController.getMaxIndex()">
          <input
            matSliderThumb
            [value]="replayController?.getProgress()"
            (input)="replayController.progressBarClick($event.target.value)" />
        </mat-slider>
        <p class="text-application-rate b map-label-1">
          {{ 'tasks.replay.current-replay-speed' | translate }} : {{ replayController?.getCurrentReproductionSpeed() }}x
        </p>
      </div>
    </ng-container>
  </div>
</div>
